import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LcvLogicHelperService {

  constructor() { }

  validaCredencialReturn(lista: any[]): boolean {
    if(lista && lista.length > 0){
      const objeto = lista.find(e => e?.name === 'SII')
      if(objeto && objeto?.configurationStatus === true){
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }
}
